import {
    Exercise,
    GhostButton,
    LabelBody,
    LabelDisplay1,
    LabelDisplay2,
    SecondaryButton,
    Spacer,
    SwirlyBox,
} from '../../components';
import { ExerciseStatus } from '../../interfaces';
import { VideoExerciseView } from '../../views';
import { ExerciseViewProps } from '../exercises';

export function Module2S1ExerciseIntro({
    exercise,
    onContinue,
}: ExerciseViewProps) {
    if (exercise.CurrentPage === 2) {
        return (
            <Exercise title="Viden om...">
                <LabelDisplay1 className="mb-10">
                    Skab et overblik
                </LabelDisplay1>
                <LabelBody className="mb-10">
                    For at kunne træne at være mere nærværende, kan det være en
                    hjælp at få overblik over de situationer, hvor det er
                    særligt svært for dig.
                </LabelBody>
                <LabelBody>
                    På den måde kan du hjælpe dig selv til at vide, hvornår du
                    skal være opmærksom på at gøre noget andet end du plejer. 
                </LabelBody>
                <SwirlyBox className="my-30">
                    Er du klar til at gå i gang?
                </SwirlyBox>
                <Spacer />
                <SecondaryButton
                    className="self-center"
                    onClick={() =>
                        onContinue({
                            status: ExerciseStatus.Completed,
                            goToNext: true,
                        })
                    }
                >
                    Lad os komme i gang
                </SecondaryButton>
                <GhostButton
                    className="mt-20 self-center"
                    onClick={() =>
                        onContinue({
                            status: ExerciseStatus.Completed,
                            goToNext: false,
                        })
                    }
                >
                    Vender tilbage senere
                </GhostButton>
            </Exercise>
        );
    } else {
        return (
            <Exercise title="Viden om...">
                <LabelDisplay2 className="mb-10">
                    Hvorfor hjælper det at træne dit nærvær?
                </LabelDisplay2>
                <LabelBody>
                    Når hovedet kører på højtryk, er man sjældent til stede nu
                    og her. Se videoen og få viden om, hvorfor det kan være en
                    hjælp at træne sin evne til at opdage, hvornår man ikke er
                    nærværende, og hvordan man kan blive det. Hvad betyder det
                    at tillade ubehag?
                </LabelBody>

                <VideoExerciseView className="mt-20" exercise={exercise} />

                <Spacer class="mt-20" />

                <SecondaryButton
                    className="self-center"
                    onClick={() =>
                        onContinue({
                            status: ExerciseStatus.InProgress,
                            pageNumber: 2,
                        })
                    }
                >
                    Videre
                </SecondaryButton>
            </Exercise>
        );
    }
}
